var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.44159C10.6767 6.44159 11.225 6.98992 11.225 7.66658C11.225 8.34325 10.6767 8.89159 10 8.89159C9.32337 8.89159 8.77504 8.34325 8.77504 7.66658C8.77504 6.98992 9.32337 6.44159 10 6.44159ZM10 11.6916C11.7355 11.6916 13.5584 12.5403 13.5584 12.9166V13.5583H6.44171V12.9166C6.44171 12.5403 8.26462 11.6916 10 11.6916ZM10 5.33325C8.71087 5.33325 7.66671 6.37742 7.66671 7.66658C7.66671 8.95283 8.71087 9.99992 10 9.99992C11.2892 9.99992 12.3334 8.95283 12.3334 7.66658C12.3334 6.37742 11.2892 5.33325 10 5.33325ZM10 10.5833C8.44546 10.5833 5.33337 11.362 5.33337 12.9166V14.6666H14.6667V12.9166C14.6667 11.362 11.5546 10.5833 10 10.5833Z",
    fill: "#5C8DE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f56ef0073d66dcc71fe846f10ea43302.svg";
export { ForwardRef as ReactComponent };